import * as yup from 'yup';
import { RendererType } from '../data-models/field-definition';
import {
  investmentTypeField,
  shareClassNameField,
  ppsField10dp,
  ViewModelInvestmentType,
} from './common-schema-defs';
import { abstractShareClassSchema } from './AbstractShareClass.schema';

export const OptionsSchema = {
  create() {
    return abstractShareClassSchema().shape({
      name: shareClassNameField().default('Options'),
      type: investmentTypeField().default(ViewModelInvestmentType.options),
      strikePrice: ppsField10dp().required().label('Strike Price').default(0.01),
      authorizedShares: yup.number().nullable().optional().label('Authorized Shares').default(null).meta({
        renderer: RendererType.integer,
      }),
      totalOptionPool: yup
        .number()
        .nullable()
        .required()
        .label('Number of Unissued Options')
        .default(0)
        .meta({
          renderer: RendererType.integer,
          description:
            'Options remaining in the pool that have not been granted to anyone. Do not include options granted to your funds or other investors in the later steps — unissued and granted options are added together for the total pool.',
        }),
      investmentDate: yup.date().nullable().optional().label('Investment Date').default(null).meta({
        renderer: RendererType.date,
      }),
    });
  },
};

export type Option = yup.InferType<ReturnType<typeof OptionsSchema.create>>;
export function createOption(overrides: Partial<Option> = {}): Option {
  return OptionsSchema.create().cast(overrides);
}
